import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  useTheme,
  Link as MuiLink,
  Avatar,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link as RouterLink } from 'react-router-dom';

const cardBackgrounds = [
  '/background_cards/1.jpeg',
  '/background_cards/2.jpeg',
  '/background_cards/3.jpeg',
  '/background_cards/4.jpeg',
  '/background_cards/5.jpeg',
  '/background_cards/6.jpeg',
];

const FreeSpaceCard: React.FC<EspacoDto> = ({
  id,
  fantasyName,
  address,
  description,
  logo,
  estabilishmentTypes,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const randomBackground = React.useMemo(
    () => cardBackgrounds[Math.floor(Math.random() * cardBackgrounds.length)],
    [],
  );
  const firstEstabilishmentType = estabilishmentTypes?.[0]?.estabilishmentTypeName;

  return (
    <Card
      sx={{
        margin: 2,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        minHeight: isMobile ? '190px' : '240px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        },
        borderRadius: 1,
        overflow: 'hidden',
        backgroundImage: `url(${randomBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(180deg, rgba(255, 255, 255,0.36) 0%, rgba(255, 255, 255, 0.68) 100%)',
          zIndex: 0,
        },
      }}
    >
      {/* Logo centralizado no topo */}
      {logo && (
        <Box
          sx={{
            zIndex: 1,
            width: '100%',
            height: isMobile ? '100px' : '130px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pt: isMobile ? 2 : 2.5,
            px: isMobile ? 2 : 3,
          }}
        >
          <Avatar
            src={logo.url}
            alt={fantasyName}
            sx={{
              width: isMobile ? '64px' : '92px',
              height: isMobile ? '64px' : '92px',
              backgroundColor: '#f5f5f5',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
              border: '2px solid white',
            }}
          />
        </Box>
      )}

      {/* Conteúdo estilo classificado */}
      <CardContent
        sx={{
          position: 'relative',
          zIndex: 1,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: isMobile ? 0.6 : 0.9,
          p: isMobile ? 1.5 : 2,
          '&:last-child': { pb: isMobile ? 1.5 : 2 },
        }}
      >
        <MuiLink
          component={Typography}
          underline="hover"
          sx={{
            display: 'block',
            color: '#000000',
            fontWeight: 700,
            fontSize: isMobile ? '0.95rem' : '1.05rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
            textAlign: 'center',
          }}
        >
          {fantasyName}
        </MuiLink>

        {firstEstabilishmentType && (
          <Typography
            variant="caption"
            sx={{
              width: '100%',
              color: 'text.secondary',
              fontWeight: 600,
              textAlign: 'center',
              lineHeight: 1.2,
            }}
          >
            {firstEstabilishmentType}
          </Typography>
        )}

        {/* Endereço compacto */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <LocationOnIcon
            sx={{ fontSize: isMobile ? 12 : 14, color: 'text.secondary', flexShrink: 0 }}
          />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              textAlign: 'center',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontSize: isMobile ? '0.7rem' : '0.75rem',
            }}
          >
            {address}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default FreeSpaceCard;
